import React from 'react';
import { useCurrency } from '../context/CurrencyContext';

/** Compact currency switcher for the navbar. Display-only (settlement stays USD). */
export default function CurrencySelector({ className = '' }) {
  const { currency, setCurrency, currencies } = useCurrency();
  return (
    <select
      value={currency}
      onChange={(e) => setCurrency(e.target.value)}
      aria-label="Display currency"
      className={`mono text-[0.78rem] bg-transparent border border-[var(--border-2)] rounded-full px-2.5 py-1.5 text-[var(--text-2)] hover:text-[var(--text)] hover:border-[var(--accent)] focus:outline-none focus:border-[var(--accent)] transition-colors cursor-pointer ${className}`}
    >
      {currencies.map((c) => (
        <option key={c} value={c} className="bg-[var(--bg)] text-[var(--text)]">{c}</option>
      ))}
    </select>
  );
}
